import { useEffect, useState, useCallback } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/** Polls the user's total unread chat message count for the header badge. */
// 1秒以内の同じ取得は使い回す（表示場所が増えるたびに同じGETが増えていた）
let _inflight = null;
let _cache = null;
const fetchUnread = () => {
  if (_cache && Date.now() - _cache.at < 1500) return Promise.resolve(_cache.data);
  if (_inflight) return _inflight;
  _inflight = axios.get(`${API}/chat/unread`)
    .then((res) => { _cache = { at: Date.now(), data: res.data }; return res.data; })
    .finally(() => { _inflight = null; });
  return _inflight;
};

export function useChatUnread(user) {
  const [count, setCount] = useState(0);
  const enabled = !!user && typeof user === 'object';

  const refresh = useCallback(async () => {
    if (!enabled) { setCount(0); return; }
    try {
      const res = { data: await fetchUnread() };
      setCount(res.data?.unread || 0);
    } catch (_e) { /* ignore */ }
  }, [enabled]);

  useEffect(() => {
    refresh();
    if (!enabled) return undefined;
    const id = setInterval(refresh, 10000);
    return () => clearInterval(id);
  }, [refresh, enabled]);

  return count;
}
